import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import createChangeIndicatedComponent from '../create-change-indicated-component';
import BaseNumber from '../number';
import omit from 'lodash/omit';

import { renderFormattedValue } from '../utils';

function Percent(props) {
  const value = (typeof props.value === 'number') ?
    Math.abs(props.value / 100) : props.value;

  return (
    <BaseNumber
      {...omit(props, 'value', 'style')}
      value={value}
      style="percent"
    >
      {(txt) => renderFormattedValue(txt, props)}
    </BaseNumber>
  );
}

Percent.defaultProps = {
  ...BaseNumber.defaultProps,
  onlyNegativeStyling: false,
};

Percent.propTypes = {
  ...BaseNumber.propTypes,
  onlyNegativeStyling: PropTypes.bool,
};

export default pure(Percent);
export const ChangeIndicatedPercent = pure(createChangeIndicatedComponent(Percent));
